export default __webpack_public_path__ + "d91515966bbfc4c8aa66bd0b25176af2.svg";